export enum SettingStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}
